// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"_41ad318","content":"_7c98920"};